import {richTextToPlain} from "../../system/components/rich-text";
export const entityKey = (item) => item?.documentId ?? item?.id ?? null;

export const isDueToday = (value) => {
    if (!value) return false;
    const date = new Date(value);
    return !Number.isNaN(date.getTime()) && date.toDateString() === new Date().toDateString();
};

export const isOverdue = (value) => {
    if (!value) return false;
    const date = new Date(value);
    const startOfToday = new Date();
    startOfToday.setHours(0, 0, 0, 0);
    return !Number.isNaN(date.getTime()) && date.getTime() < startOfToday.getTime();
};

const PRIORITY_LEVELS = {high: "critical", medium: "important", low: "normal"};
export const getPriority = (task) => PRIORITY_LEVELS[task?.priority] ?? null;

export const priorityWeight = {critical: 3, important: 2, normal: 1};

export function createMobileTaskFilters() {
    return {search: "", scope: "today", secondary: "all"};
}

export function filterMobileTasks(tasks, filters = createMobileTaskFilters()) {
    const needle = filters.search.trim().toLocaleLowerCase();
    return tasks.filter((task) => {
        const searchable = [task.title, richTextToPlain(task.description), ...(task.projects || []).map((project) => project.title)].filter(Boolean).join(" ").toLocaleLowerCase();
        if (needle && !searchable.includes(needle)) return false;
        if (filters.scope === "done" && task.taskStatus !== "done") return false;
        if (filters.scope !== "done" && task.taskStatus === "done") return false;
        if (filters.scope === "today" && !isDueToday(task.dueDate)) return false;
        if (filters.scope === "next" && (!task.dueDate || isDueToday(task.dueDate) || isOverdue(task.dueDate))) return false;
        if (filters.secondary === "high-priority") return false;
        if (filters.secondary === "overdue" && (task.taskStatus === "done" || !isOverdue(task.dueDate))) return false;
        if (filters.secondary === "waiting") return false;
        return true;
    });
}

export const sortTasks = (items = []) => items
    .map((task) => ({...task, mobilePriority: getPriority(task)}))
    .sort((left, right) => {
        const priorityDifference = (priorityWeight[right.mobilePriority] || 0) - (priorityWeight[left.mobilePriority] || 0);
        if (priorityDifference) return priorityDifference;
        const leftDue = left.dueDate ? new Date(left.dueDate).getTime() : Number.MAX_SAFE_INTEGER;
        const rightDue = right.dueDate ? new Date(right.dueDate).getTime() : Number.MAX_SAFE_INTEGER;
        return leftDue - rightDue;
    });

export function getProjectProgress(project) {
    const deliverables = project?.deliverables || [];
    if (!deliverables.length) return 0;
    const completed = deliverables.filter((item) => ["done", "completed", "ready"].includes(item?.deliverableStatus || item?.status)).length;
    return Math.round((completed / deliverables.length) * 100);
}
